/* eslint-disable max-lines */

import { createIconFromImg } from '../../../internal';
import icon from './ToggleHeartOff.svg';

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var IconToggleHeartOff24 = createIconFromImg('IconToggleHeartOff24', icon);